import { render, staticRenderFns } from "./OnayamiCreate.vue?vue&type=template&id=c5dd700a&"
import script from "./OnayamiCreate.vue?vue&type=script&lang=ts&"
export * from "./OnayamiCreate.vue?vue&type=script&lang=ts&"
import style0 from "./OnayamiCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports